import { resolveEnvironment, type Environment } from "@vellum/micro-app-auth";

const HUB_URLS: Record<Environment, string> = {
  local: "http://hub.local.vibestack.cloud",
  dev: "https://hub.dev.vellum.health",
  prod: "https://hub.vellum.health",
};

export function getHubUrl(): string {
  return HUB_URLS[resolveEnvironment()];
}
